import { Grid, Paper, Table, TableBody, TableContainer } from "@mui/material";
import React from "react";
import { LoadingRow } from "../../components/template/row/LoadingRow";
import { useAppSelector } from "../../store/hooks";
import { ReportsFilter } from "./common/ReportsFilter";
import { ReportTemplateRow } from "./templates/ReportTemplateRow";
import { ReportTemplatesHeader } from "./templates/ReportTemplatesHeader";

const colSpan = 7;

export const ReportTemplates = () => {
  const reports = useAppSelector((s) => s.reports.templates ?? []);
  const loadingReports = useAppSelector((s) => s.reports.loadingReports);
  return (
    <Grid container spacing={1} rowSpacing={2} alignItems={"flex-end"}>
      <Grid item xs={12}>
        <ReportsFilter mode={"templates"} />
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="Шаблоны отчетов">
            <ReportTemplatesHeader />
            <TableBody>
              {loadingReports || reports.length === 0 ? (
                <LoadingRow colSpan={colSpan} loading={loadingReports} />
              ) : null}
              {reports.map((info) => (
                <ReportTemplateRow key={`${info.id}`} info={info} />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
    </Grid>
  );
};
